'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useIsHydrated } from '@hooks/useIsHydrated';
import { useIsInitialPathname, useNavigationEvent } from '@hooks/useNavigationEvent';
import { PopState } from '@hooks/usePopState';
import { sendPageAnalytics } from '@lib/analytics';

export function NavigationEvents() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isHydrated = useIsHydrated();
  const isInitialPath = useIsInitialPathname();

  // Send segment analytics on initial load and every route change
  const params = searchParams?.toString() ? `?${searchParams}` : ``;
  const url = `${pathname}${params}`;

  if (isInitialPath && isHydrated) sendPageAnalytics({ url, initialLand: true });
  useNavigationEvent(() => sendPageAnalytics({ url, initialLand: false }));

  // Set popState false on `routeChangeComplete` event
  useNavigationEvent(() => (PopState.isPopStateEvent = false));

  return null;
}
